import { createSelector } from '@ngrx/store';
import { getMemberInterfaceValidation } from '../getMemberInterfaceValidation/get-member-interface-validation.selector';

export const getMemberInterfaceValidationVerificationStatus = createSelector(getMemberInterfaceValidation, (memberInterfaceValidation) => memberInterfaceValidation.status);
